import { ColorsScheme } from '../palette/colors';

export const getDowntimeReportWidgetTheme = () =>
  ({
    axes: {
      left: {
        borderColor: 'coolGrey30',
        color: 'coolGrey60',
      },
      bottom: {
        color: 'coolGrey60',
      },
    },
    chart: {
      background: 'coolGrey5',
      colors: [
        'chartStackedBar0',
        'chartStackedBar1',
        'chartStackedBar2',
        'chartStackedBar3',
        'chartStackedBar4',
        'chartStackedBar5',
        'chartStackedBar6',
        'chartStackedBar7',
        'chartStackedBar8',
        'chartStackedBar9',
        'chartStackedBar10',
        'chartStackedBar11',
        'chartStackedBar12',
      ],
      bar: {
        stroke: 'coolGrey30',
        active: {
          backgroundColor: 'coolGrey20',
        },
      },
      scales: {
        color: 'coolGrey30',
      },
    },
  }) as const satisfies ColorsScheme;

export type DowntimeReportWidgetTheme = ReturnType<typeof getDowntimeReportWidgetTheme>;
